import { apiClient } from "@/lib/api-client";
import type { ConfigPersentase } from "./get-config-persentase";

export const postConfigPersentase = async (
  payload: ConfigPersentase,
): Promise<any> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const res = await apiClient(`${baseUrl}/api/v1/config/persentase`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });
  return res;
};
